module.exports = __webpack_public_path__ + "img/default_doctor.77492875.png";